import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, InputNumber } from "antd";
import { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";

export default function TUTForm({ tut, onSubmit, onClose, loading }: any) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (tut) form.setFieldsValue(tut);
  }, [tut, form]);

  const handleFinish = (values: any) => onSubmit(values);

  return (
    <Form form={form} layout="horizontal" onFinish={handleFinish}>
      <Modal.Body>
        <Form.Item
          label="Eccentrico"
          name="ecc"
          rules={[
            {
              required: true,
              message: "I secondi in Eccentrico sono obbligatori",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Stop Eccentrico"
          name="stopEcc"
          rules={[
            {
              required: true,
              message: "I secondi in Stop Eccentrico sono obbligatori",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Concentrico"
          name="conc"
          rules={[
            {
              required: true,
              message: "I secondi in Concentrico sono obbligatori",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Stop Concentrico"
          name="stopConc"
          rules={[
            {
              required: true,
              message: "I secondi in Stop Concentrico sono obbligatori",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button
          onClick={onClose}
          size="sm"
          variant="light"
          className="border me-2"
        >
          Annulla
        </Button>
        <Button variant="success" size="sm" type="submit" disabled={loading}>
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <>
              <FontAwesomeIcon icon={faSave} />
              <span className="ms-2">Salva</span>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );
}
